module.exports = __webpack_public_path__ + "static/media/air-filter-change-red.fe926609.svg";